import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { ValList } from '@/common/val/ValList';
import { IndirSaleLineForm } from './IndirSaleLineForm';

export const IndirSaleLineDetail = () => {

  const { entityObj } = useEntityMgr();

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <IndirSaleLineForm /> },
    { id: 'valTab', label: 'Validations', content: <ValList parentEntity="INDIR_SALE_LINE" parentEntityId={entityObj.id} /> }
  ];

  return (
    <EntityDetail tabSpecs={tabSpecs} />
  )
}